module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/instagram_icon-73eaea893d5a4137a6272e874189eee7.svg";